import { Context } from "../Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { ToastContainer, Toast } from 'react-bootstrap';
import loading from '../Assets/Images/cs-loading.svg';
function Loading() {
    const [state, dispatch] = useContext(Context);

    return (<>
        {state.loading &&
            <div style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                zIndex: 9999,
                top: 0,
                left: 0,
                backgroundColor: 'rgba(205, 205, 205, 0.4)'
            }}>
                <img src={loading} alt='mySvgImage' style={{
                    position: 'absolute',
                    margin: 'auto',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }} />
            </div>
        }</>
    );
}
export default Loading;